import { useEffect, useState } from "react";
import logoClubbage from "../assets/images/logo_clubbage.png";
import packageJson from "../../package.json";

function Home({
    onNewGame,
    onContinue,
    statusText,
    useAIOpponent,
    onToggleAIOpponent,
    isSfxEnabled,
    onToggleSfxEnabled,
    sfxVolume,
    onChangeSfxVolume,
    onUserInteraction,
    onPlayClickSfx
}) {
    const [showCredits, setShowCredits] = useState(false);
    const [showContinueInput, setShowContinueInput] = useState(false);
    const [passcode, setPasscode] = useState("");
    const [errorText, setErrorText] = useState("");
    const appVersion = packageJson.version;

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowCredits(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    const handleContinue = () => {
        if (typeof onUserInteraction === "function") {
            onUserInteraction();
        }
        if (typeof onPlayClickSfx === "function") {
            onPlayClickSfx();
        }

        const isAllowed = onContinue(passcode.trim());

        if (!isAllowed) {
            setErrorText("Incorrect passcode. Hint: 1122");
            return;
        }

        setErrorText("");
    };

    return (
        <section className="screen screen-home">
            <div className={`text-center home-hero ${showCredits ? "home-hero--shifted" : ""}`}>
                <div className="subscreen_game_logo">
                    <div>
                        <img src={logoClubbage} className="game_logo_banner" alt="Clubbage!!"/>
                        <p className="mb-0 mt-3">Cards. Corners. Chaos.</p>
                    </div>
                </div>

                <div className="subscreen_game_input">
                    <div>
                        <div>
                            <button
                                type="button"
                                className="me-1 menu-btn"
                                onClick={() => {
                                    if (typeof onUserInteraction === "function") {
                                        onUserInteraction();
                                    }
                                    if (typeof onPlayClickSfx === "function") {
                                        onPlayClickSfx();
                                    }
                                    onNewGame();
                                }}
                            >
                                New Game
                            </button>
                            <button
                                type="button"
                                className="ms-1 menu-btn menu-btn--secondary"
                                onClick={() => {
                                    if (typeof onUserInteraction === "function") {
                                        onUserInteraction();
                                    }
                                    if (typeof onPlayClickSfx === "function") {
                                        onPlayClickSfx();
                                    }
                                    setShowContinueInput((prev) => !prev);
                                }}
                            >
                                Continue
                            </button>
                            {showContinueInput && (
                                <div className="continue-panel">
                                    <div className="input-group">
                                        <input id="continue-passcode" type="text" className="form-control" maxLength={4} placeholder="Enter 4-digit passcode:"
                                            aria-label="Enter 4-digit passcode:" aria-describedby="button-addon2"
                                            value={passcode}
                                            onFocus={() => {
                                                if (typeof onUserInteraction === "function") {
                                                    onUserInteraction();
                                                }
                                            }}
                                            onChange={(event) => setPasscode(event.target.value)} />
                                        <button className="menu-btn--tertiary" type="button" onClick={handleContinue}>Enter Corner</button>
                                    </div>
                                    {errorText ? <p className="home-error mb-0 mt-3">{errorText}</p> : null}
                                </div>
                            )}

{/*
                            <section className="audio-controls" aria-label="Sound effects controls">
                                <label className="audio-controls__toggle">
                                    <input
                                        type="checkbox"
                                        checked={isSfxEnabled}
                                        onChange={(event) => {
                                            if (typeof onUserInteraction === "function") {
                                                onUserInteraction();
                                            }
                                            onToggleSfxEnabled(event.target.checked);
                                        }}
                                    />
                                    <span>Sound Effects</span>
                                </label>
                                <label className="audio-controls__volume" htmlFor="sfx-volume">
                                    <span>SFX Volume: {sfxVolume}%</span>
                                    <input
                                        id="sfx-volume"
                                        type="range"
                                        min="0"
                                        max="100"
                                        step="1"
                                        value={sfxVolume}
                                        onChange={(event) => {
                                            if (typeof onUserInteraction === "function") {
                                                onUserInteraction();
                                            }
                                            onChangeSfxVolume(Number(event.target.value));
                                        }}
                                    />
                                </label>
                            </section>
*/}
                            <div className="form-check form-switch d-none">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="switchAIOpponent"
                                    checked={useAIOpponent}
                                    onChange={(event) => onToggleAIOpponent(event.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="switchAIOpponent">Spar with a Bot</label>
                            </div>
                            <article className="home-credits text-start">
                                <div>
                                    <h5 className="mb-3">The Undercard Story</h5>
                                    <p>Deal with and discard a cast of challengers, as you work your way from the undercard to the main event.</p>
                                    <p>Each victory brings you closer to claim the title of, "World Card-Fighter Champion".</p>
                                    <small className="score-line">&copy;{statusText} v{appVersion}</small>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Home;
